import { render, staticRenderFns } from "./classifySearch.vue?vue&type=template&id=1ad507da&scoped=true"
import script from "./classifySearch.vue?vue&type=script&lang=js"
export * from "./classifySearch.vue?vue&type=script&lang=js"
import style0 from "./classifySearch.vue?vue&type=style&index=0&id=1ad507da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad507da",
  null
  
)

export default component.exports